import { Box, Divider } from '@material-ui/core';
import { CheckoutSession } from '@nemuru-eng/js-api-client';

import { FlexColumn } from '@/components/shared/components/FlexColumn';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';

interface BillingAndShippingCardProps {
  billing: CheckoutSession['billing'];
  shipping: CheckoutSession['shipping'];
}

export const BillingAndShippingCard = ({ billing, shipping }: BillingAndShippingCardProps) => {
  if (!billing && !shipping) {
    return null;
  }

  return (
    <>
      {billing && (
        <>
          <Font variant="h5" color="title">
            <Text strong tId={'BILLING_ADDRESS'} />
          </Font>
          <FlexColumn gridGap={4} pt={1}>
            <Font className="overflow-text-ellipsis" variant="subtitle2" display="block">
              {billing.customer.name.first} {billing.customer.name.last}
            </Font>
            <Font className="overflow-text-ellipsis" variant="body2" display="block">
              {billing.address.streetAddress}
              {billing.address.streetAddress2 && `, ${billing.address.streetAddress2}`}
            </Font>
            <Font className="overflow-text-ellipsis" variant="body2" display="block">
              {billing.address.postalCode}
              {', '}
              {billing.address.city}
            </Font>
            <Font className="overflow-text-ellipsis" variant="body2" display="block">
              {billing.address.country}
            </Font>
          </FlexColumn>
        </>
      )}
      {billing && shipping && (
        <Box py={3}>
          <Divider light />
        </Box>
      )}
      {shipping && (
        <>
          <Font variant="h5" color="title">
            <Text strong tId={'SHIPPING_ADDRESS'} />
          </Font>
          <FlexColumn gridGap={4} pt={1}>
            <Font className="overflow-text-ellipsis" variant="subtitle2" display="block">
              {shipping.customer.name.first} {shipping.customer.name.last}
            </Font>
            <Font className="overflow-text-ellipsis" variant="body2" display="block">
              {shipping.address.streetAddress}
              {shipping.address.streetAddress2 && `, ${shipping.address.streetAddress2}`}
            </Font>
            <Font className="overflow-text-ellipsis" variant="body2" display="block">
              {shipping.address.postalCode}
              {', '}
              {shipping.address.city}
            </Font>
            <Font className="overflow-text-ellipsis" variant="body2" display="block">
              {shipping.address.country}
            </Font>
            <Font className="overflow-text-ellipsis" variant="body2" display="block">
              <Text tId="SHIPPING_NAME" />
              {': '}
              {shipping.name}
            </Font>
          </FlexColumn>
        </>
      )}
    </>
  );
};
